import { useState } from 'react';
export var useModalMode = function () {
    var _a = useState('compact'), modalMode = _a[0], setModalMode = _a[1];
    var handleModalModeChange = function (mode) {
        requestAnimationFrame(function () {
            setModalMode(mode);
        });
    };
    var expandModal = function () {
        handleModalModeChange('expanded');
    };
    var compactModal = function () {
        handleModalModeChange('compact');
    };
    return { modalMode: modalMode, expandModal: expandModal, compactModal: compactModal };
};
